import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from 'i18next-browser-languagedetector';
import en from './en.json';
import de from './de.json';
import da from './da.json';
import fi from './fi.json';
import fr from './fr.json';
import it from './it.json';
import nl from './nl.json';
import pl from './pl.json';
import sv from './sv.json';

// languages
const resources = {en, de, da, fi, fr, it, nl, pl, sv};

i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources,
    fallbackLng: "en",
    keySeparator: false,
    interpolation: {
      escapeValue: false
    }
  });

  i18n.use(LanguageDetector).init({detection: {order: ['localStorage', 'navigator'], lookupLocalStorage: 'language'}});

export default i18n;